import type { CreateCardFormValues } from './types';

type Props = {
  cardHolderName: string;
  initialValues?: Partial<CreateCardFormValues>;
};

export const getDefaultValues = ({ cardHolderName, initialValues }: Props) => {
  const defaultValues: CreateCardFormValues = {
    currencyCode: '',
    cardNumber: '',
    isCardholderCard: false,
    cardholderName: cardHolderName || '',
    templateName: '',
  };

  return {
    ...defaultValues,
    ...initialValues,
  };
};
